import { Injectable, NgZone, inject } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

export const PAGINACAO_LOADING_TEMPO_MINIMO_MS = 300
export const PAGINACAO_LOADING_TEMPO_MAXIMO_MS = 30_000

@Injectable({
  providedIn: 'root',
})
export class PaginacaoLoadingService {
  private pendentes = 0
  private visivelDesde = 0
  private ocultarTimer: ReturnType<typeof setTimeout> | null = null
  private maximoTimer: ReturnType<typeof setTimeout> | null = null
  private readonly zone = inject(NgZone)
  private readonly loadingSubject = new BehaviorSubject(false)

  readonly carregando$ = this.loadingSubject.asObservable()

  get carregando(): boolean {
    return this.loadingSubject.value
  }

  iniciar(): void {
    this.zone.run(() => {
      this.limparTimer(this.ocultarTimer)
      this.ocultarTimer = null

      this.pendentes += 1
      if (this.pendentes === 1) {
        this.visivelDesde = Date.now()
        this.loadingSubject.next(true)
        this.agendarTimeoutMaximo()
      }
    })
  }

  finalizar(): void {
    this.zone.run(() => {
      if (this.pendentes === 0) {
        return
      }

      this.pendentes -= 1
      if (this.pendentes > 0) {
        return
      }

      const restante = Math.max(
        0,
        PAGINACAO_LOADING_TEMPO_MINIMO_MS - (Date.now() - this.visivelDesde)
      )
      this.ocultarTimer = setTimeout(() => {
        if (this.pendentes === 0) {
          this.ocultar()
        }
        this.ocultarTimer = null
      }, restante)
    })
  }

  resetar(): void {
    this.zone.run(() => this.ocultar())
  }

  private agendarTimeoutMaximo(): void {
    this.limparTimer(this.maximoTimer)
    this.maximoTimer = setTimeout(() => {
      this.maximoTimer = null
      this.resetar()
    }, PAGINACAO_LOADING_TEMPO_MAXIMO_MS)
  }

  private ocultar(): void {
    this.pendentes = 0
    this.limparTimer(this.ocultarTimer)
    this.ocultarTimer = null
    this.limparTimer(this.maximoTimer)
    this.maximoTimer = null
    if (this.loadingSubject.value) {
      this.loadingSubject.next(false)
    }
  }

  private limparTimer(timer: ReturnType<typeof setTimeout> | null): void {
    if (timer) {
      clearTimeout(timer)
    }
  }
}
